var BlockView = require('views/block/base-block-view');
import AsyncBlockService from 'services/async-block-service';
var FeedbackService = require('services/feedback-service');
var LocaleService = require('services/locale-service');
var EnrollmentDataService = require('services/enrollment-data-service');

/**
 * @View
 *
 * @name form
 * @type block
 * @desciption Details for Form
 * @content
 *  @contains @advanced 'feedback' with:
 *    @prop region type={string} title="Feedback Region"
 *    @prop scroll_into_view type={boolean} title="Auto-scroll to Feedback Region" default=false
 *    @includes blocks: {{blocks}}
 *  @end
 *  @contains 'data' with:
 *    @prop prepopulate type={boolean} title="Prepopulate data?"
 *    @prop key type={string} title="Data Key"
 *    @contains 'submit' title="Data Submit" with:
 *      @prop @advanced class type="string" title="Submit Class" default="btn"
 *      @prop text type="string" title="Submit Button Label" default="submitButtonLabel"
 *      @prop sprite type="string" title="Submit Sprite" @allow imagePicker
 *    @end
 *  @end
 *  @prop validate_on_submit type={boolean} title="Validate form on submit?"
 *  @prop auto_complete type={boolean} title="Auto Complete?"
 *  @prop inputs_class type={string} title="Inputs class" description="CSS Class(es) for Inputs"
 *  @contains @array_of 'inputs' with:
 *    @prop @advanced wrapper_class type={string} title="Wrapper Class" description="e.g., 'choice-card'"
 *    @contains @advanced helptext with:
 *      @prop text type={string} title="Input Help Text"
 *      @prop [position] type={string} title="Input Help Text Position"
 *        "top"
 *        "bottom"
 *    @end
 *    @prop [type] type={string} title="Input Type" default="text"
 *      "button-radio"
 *      "text"
 *      "textarea"
 *      "select"
 *      "radio"
 *      "checkbox"
 *      "number"
 *      "toggle"
 *      "date"
 *    @prop id type={string} title="Input ID"
 *  @end
 *  @contains @advanced @array_of 'buttons' with:
 *    @prop button_class type={string} title="Button Class"
 *    @prop exec type={string} title="Button Execute"
 *    @prop id type={string} title="Button ID"
 *    @prop text type={string} title="Button Text"
 *  @end
 */
var FormView = BlockView.extend({
  regions: {
    inputs: '.inputs',
  },
  load: function () {
    AsyncBlockService.load(['input'], ['views/block/input/input-collection-view']).then(([InputCollectionView]) => {
      var inputCollectionView = new InputCollectionView({
        region: 'inputs',
        collection: new Chaplin.Collection(this.model.get('inputs')),
      });
      this.subview('inputs', inputCollectionView);

      if (this.model.get('auto_complete') === true) {
        this.readyToGo();
      }

      var self = this;
      this.delegate('click', 'input[type="submit"]', function (e) {
        e.preventDefault();
        var button = $(e.currentTarget);
        if (button.data('execute')) {
          var args = [];
          _.each(self.model.get('inputs'), function (input) {
            args.push($('#' + input.id).val());
          });
          self.script[button.data('execute')].apply(self.script, args);
        }
        FeedbackService.renderFeedbackWithElementState(this.model.get('feedback'), self.$el, 'correct', ['correct'], {
          completed: function () {
            self.readyToGo();
          },
          noFeedback: _.bind(this.readyToGo, this),
        });
        self.$('form').submit();
      });
      this.delegate('click', 'input[type="checkbox"]', function (e) {
        const $checkbox = $(e.currentTarget);
        if ($checkbox.is(':checked')) {
          $checkbox.next().addClass('checked');
        } else {
          $checkbox.next().removeClass('checked');
        }
      });
      this.delegate('click', 'input[type="radio"]', function (e) {
        const $radio = $(e.currentTarget);
        if ($radio.not(':checked')) {
          $radio.siblings('label').siblings().removeClass('checked');
          $radio.next().addClass('checked');
        }
      });
      this.bindEnrollmentData();
      this.clearForm();
    });
  },
  bindEnrollmentData: function () {
    this.model.property('data', data => {
      if (data.prepopulate !== undefined && data.prepopulate === true) {
        let enrollmentData = EnrollmentDataService.getData(data.key, { defaultValue: false });
        if (enrollmentData !== false && enrollmentData !== undefined) {
          Object.keys(enrollmentData).forEach(key => {
            let value = enrollmentData[key];
            if (Array.isArray(value)) {
              value.forEach(item => {
                this.prePopulateInput(key, item);
              });
            } else {
              this.prePopulateInput(key, value);
            }
          });
        }
      }
    });

    this.delegate('click', '.sprite', () => {
      this.$('form input[type="submit"]').click();
    });

    this.delegate('submit', 'form', e => {
      e.preventDefault();
      // show reset button
      if (this.model.get('allow_reset')) {
        this.$el.find('#reset-form').removeClass('hidden');
      }
      // The form gets the validation on inputs delegated
      const validateOnSubmit = this.model.get('validate_on_submit');
      if (validateOnSubmit) {
        const errors = [];
        this.subview('inputs').subviews.forEach(subview => {
          //Validate only input fields type number
          if (subview.model.attributes.type == 'number') {
            const errMsg = subview._validateOnSubmit();
            if (errMsg) {
              errors.push(errMsg);
            }
          }
        });
        if (errors.length > 0) {
          // Publish the alert so the page-view can display it.
          Chaplin.mediator.publish(
            'action:alert',
            'error',
            LocaleService.t('inputErrorMessages.title'),
            errors.join('<br /><br />'),
            '',
            true
          );
        }
      }

      // Check if browser supports reporting form validations, hint: Safari doesn't
      if (!('reportValidity' in document.createElement('form')) && this.$('form').get(0) !== undefined) {
        let form = this.$('form');
        if (!form.get(0).checkValidity()) {
          form.find(':invalid').each(function () {
            let error = $(`<span class="invalid no-reporting" role="alert">${$(this).get(0).validationMessage}</span>`);
            if ($(this).next('.invalid.no-reporting').length < 1) {
              $(this).after(error);
              $(this).focus(function () {
                error.fadeOut('fast', function () {
                  error.remove();
                });
              });
            }
          });
          return false;
        }
      }

      this.model.property('data', data => {
        var enrollmentData = EnrollmentDataService.getData(data.key, { defaultValue: {} });

        this.model.get('inputs').forEach(input => {
          if (
            input.attributes !== undefined &&
            input.attributes.name !== undefined &&
            enrollmentData[input.attributes.name] !== undefined
          ) {
            delete enrollmentData[input.attributes.name];
          }
          if (input.name !== undefined && enrollmentData[input.name] !== undefined) {
            delete enrollmentData[input.name];
          }
        });

        let formData = this.$('form')
          .serializeArray()
          .reduce((result, input) => {
            if (input.name !== undefined && input.value !== undefined) {
              if (result[input.name] !== undefined) {
                if (Array.isArray(result[input.name])) {
                  result[input.name].push(input.value);
                } else {
                  result[input.name] = [result[input.name], input.value];
                }
              } else {
                result[input.name] = input.value;
              }
            }
            return result;
          }, enrollmentData);

        if (this.model.has('validation')) {
          let validation = this.script[this.model.get('validation')];
          if (validation !== undefined && typeof validation === 'function' && validation(this, this.pageView)) {
            EnrollmentDataService.saveData(data.key, formData);
            FeedbackService.renderFeedbackWithElementState(
              this.model.get('feedback'),
              this.$el,
              'correct',
              ['correct'],
              {
                completed: function () {
                  this.readyToGo();
                }.bind(this),
                noFeedback: _.bind(this.readyToGo, this),
              }
            );
          }
        } else {
          EnrollmentDataService.saveData(data.key, formData);
          FeedbackService.renderFeedbackWithElementState(this.model.get('feedback'), this.$el, 'correct', ['correct'], {
            completed: function () {
              this.readyToGo();
            }.bind(this),
            noFeedback: _.bind(this.readyToGo, this),
          });
        }
      });
    });
    return this;
  },
  clearForm: function () {
    this.delegate('click', '#reset-form', e => {
      const formId = this.$el.find(`${this.model.cid}-form`).selector;
      // reset form inputs
      $(`#${formId}`).trigger('reset');
      // reset checkboxes and radio inputs
      this.$el.find('label.checked').removeClass('checked');
      // remove feedback if it exists
      if (this.model.get('feedback')) {
        FeedbackService.removeFeedback(this, this.model.get('feedback'));
      }
      // hide reset button
      this.$el.find('#reset-form').addClass('hidden');
    });
  },
  prePopulateInput: function (name, value) {
    let input = this.$(`form [name="${name}"]`);

    if (input.is(':checkbox') || input.is(':radio')) {
      input.each(function () {
        let $this = $(this);
        if ($this.val() == value) {
          $this.prop('checked', true).next().addClass('checked');
        }
      });
    } else {
      input.val(value);
    }
  },
});

module.exports = FormView;
